"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = __importStar(require("../../icons"));
const switch_base_1 = __importDefault(require("../switch-base/switch-base"));
function CheckboxIcon({ checked, indeterminate, ...props }) {
    return react_1.default.createElement(indeterminate ? icons_1.MinusIcon : checked ? icons_1.CheckIcon : icons_1.default, { strokeWidth: 4, ...props });
}
exports.Checkbox = react_1.default.forwardRef(function Checkbox({ indeterminate, value, ...props }, ref) {
    return (react_1.default.createElement(switch_base_1.default, { ref: ref, "aria-checked": indeterminate ? "mixed" : !!value, checked: !!value, hidden: true, icon: CheckboxIcon, indeterminate: indeterminate, type: "checkbox", ...props }));
});
exports.default = exports.Checkbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2tib3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2NoZWNrYm94L2NoZWNrYm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGtEQUEwQjtBQUUxQixxREFBeUQ7QUFDekQsNkVBQThGO0FBTTlGLFNBQVMsWUFBWSxDQUFDLEVBQUUsT0FBTyxFQUFFLGFBQWEsRUFBRSxHQUFHLEtBQUssRUFBdUI7SUFDN0UsT0FBTyxlQUFLLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsaUJBQVMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxpQkFBUyxDQUFDLENBQUMsQ0FBQyxlQUFJLEVBQUUsRUFBRSxXQUFXLEVBQUUsQ0FBQyxFQUFFLEdBQUcsS0FBSyxFQUFFLENBQUMsQ0FBQztBQUNuSCxDQUFDO0FBRVksUUFBQSxRQUFRLEdBQUcsZUFBSyxDQUFDLFVBQVUsQ0FBa0MsU0FBUyxRQUFRLENBQUMsRUFBRSxhQUFhLEVBQUUsS0FBSyxFQUFFLEdBQUcsS0FBSyxFQUFFLEVBQUUsR0FBRztJQUNqSSxPQUFPLENBQ0wsOEJBQUMscUJBQVUsSUFDVCxHQUFHLEVBQUUsR0FBRyxrQkFDTSxhQUFhLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssRUFDL0MsT0FBTyxFQUFFLENBQUMsQ0FBQyxLQUFLLEVBQ2hCLE1BQU0sUUFDTixJQUFJLEVBQUUsWUFBWSxFQUNsQixhQUFhLEVBQUUsYUFBYSxFQUM1QixJQUFJLEVBQUMsVUFBVSxLQUNYLEtBQUssR0FDVCxDQUNILENBQUM7QUFDSixDQUFDLENBQUMsQ0FBQztBQUVILGtCQUFlLGdCQUFRLENBQUMifQ==